



































import Vue from 'vue';
import { mapActions } from 'vuex';
import { capitalize } from 'lodash';
import ZenButton from '@reciprocity/button';

import SearchableList from '@/components/object_mapper/SearchableList.vue';
import ColumnTitle from '@/components/object_mapper/ColumnTitle.vue';
import ScopingItem from './ScopingItem.vue';
import setStatus from '../mixins/setStatus';

export default Vue.extend({
  name: 'ScopingListing',
  components: {
    ColumnTitle,
    SearchableList,
    ScopingItem,
    ZenButton,
  },
  mixins: [setStatus],
  props: {
    parentId: {
      type: String,
      default: null,
    },
    scoping: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: {
        scope: false,
        unscope: false,
      },
    };
  },
  computed: {
    items() {
      return this.rawItems || [];
    },
    unscopedItems() {
      return this.items.filter(i => i.status.value !== 'In Scope');
    },
    scopedItems() {
      return this.items.filter(i => i.status.value === 'In Scope');
    },
    scopingButtons() {
      return {
        unscope: {
          items: this.scopedItems,
          variant: 'danger',
          text: 'Unscope all',
        },
        scope: {
          items: this.unscopedItems,
          variant: 'success',
          text: 'Scope all',
        },
      };
    },
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    capitalize,
    async scopeAll(items: [{ id: string }], action: 'scope' | 'unscope') {
      const newStatus = action === 'scope' ? 'In Scope' : 'Draft';
      try {
        this.loading[action] = true;
        await Promise.all(items.map(i => this.setStatus(newStatus, i.id, i.__typename)));
      } catch {
        this.showAlert({
          type: 'error',
          message: `Oops, something went wrong. Some of the ${capitalize(
            this.scoping
          )} might not have been ${action}d.`,
        });
      } finally {
        this.loading[action] = false;
      }
    },
  },
  apollo: {
    rawItems: {
      query() {
        if (this.scoping === 'standards') {
          return require('../queries/ProgramStandards.gql');
        } else if (this.scoping === 'sections') {
          return require('../queries/StandardSections.gql');
        } else if (this.scoping === 'objectives') {
          return require('../queries/SectionObjectives.gql');
        }
      },
      variables() {
        return { parentId: this.parentId };
      },
      update(result) {
        return result.node.mappings[this.scoping].edges.map(e => e.node);
      },
      skip() {
        return this.parentId === null;
      },
    },
  },
});
